import type { SubscribePayload } from 'graphql-ws';
import {
	type CacheConfig,
	Observable,
	type RequestParameters,
	type SubscribeFunction,
	type Variables,
} from 'relay-runtime';

import { getClient, getSinkError, type SinkError } from '@atlassian/graphql-subscription';

export const subscribe: SubscribeFunction = (
	{ id, name: operationName }: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
) =>
	Observable.create((sink) => {
		const client = getClient();
		if (!client) {
			return sink.error(new Error('Unable to create subscription client'));
		}

		const replayConfig = cacheConfig?.metadata?.replay || undefined;

		const payload: SubscribePayload = {
			query: '',
			operationName,
			variables,
			extensions: {
				pq: id,
				...(replayConfig && { replay: replayConfig }),
			},
		};

		let requestId: string | null;

		return client.subscribe(payload, {
			...sink,
			next: (value) => {
				// @ts-expect-error agg prop is missing on generic "extensions" type
				const aggRequestId = value?.extensions?.gateway?.request_id;
				requestId = aggRequestId ?? requestId;
				// @ts-expect-error incompatible types between two libraries
				sink.next(value);
			},
			error: (sinkError: SinkError) => {
				const errorInfo = getSinkError(sinkError);

				sink.error(errorInfo);
			},
		});
	});
